<template>
  <base-floating-card @close="close">
    <div id="email-composition-card">
      <Select
        class="scs-input"
        heading="From:"
        :initial="source"
        :options="emailAddresses"
        @input="emailInput"
      />
      <Input
        class="scs-input"
        heading="Subject:"
        @scs-input="subjectInput"
        :error="errors.subject"
      />
      <TextArea
        class="scs-input"
        heading="Body:"
        @scs-input="bodyInput"
        :error="errors.body"
      />
      <Button text="Send" class="scs-input scs-button" @click="submitEmail" />
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import Select from "@/Components/Elements/Select.vue";
import Input from "@/Components/Elements/Input.vue";
import TextArea from "@/Components/Elements/TextArea.vue";
import Button from "@/Components/UI/Button.vue";

export default {
  data() {
    return {
      source: undefined,
      subject: undefined,
      body: undefined,
      errors: {
        source: false,
        subject: false,
        body: false,
      },
      email: {
        Destination: {
          BccAddresses: [],
          CcAddresses: [],
          ToAddresses: [],
        },
        Message: {
          Body: {
            Html: {
              Charset: "UTF-8",
              Data: null,
            },
            Text: {
              Charset: "UTF-8",
              Data: null,
            },
          },
          Subject: {
            Charset: "UTF-8",
            Data: null,
          },
        },
        ReplyToAddresses: [this.$store.getters.user.email],
        Source: null,
      },
    };
  },
  computed: {
    emailAddresses() {
      return this.$store.getters.businessEmailAddresses;
    },
    businessName() {
      return this.$store.getters.businessName;
    },
    errorsExist() {
      return this.errors.body || this.errors.subject;
    },
  },
  methods: {
    emailInput(email) {
      this.source = email;
    },
    subjectInput(value) {
      this.subject = value;
    },
    bodyInput(value) {
      this.body = value;
    },
    validation() {
      if (!this.body) {
        this.errors.body = true;
      } else {
        this.errors.body = false;
      }
      if (!this.subject) {
        this.errors.subject = true;
      } else {
        this.errors.subject = false;
      }
    },
    async submitEmail() {
      this.validation();
      if (!this.errorsExist) {
        this.email.Source = `${this.businessName} < ${this.source} >`;
        this.email.Message.Subject.Data = this.subject;
        this.email.Message.Body.Html.Data = this.body;
        this.email.Message.Body.Text.Data = this.body;
        this.email.Destination.ToAddresses.push(this.contact.email);
        await this.$store.dispatch("sendEmail", this.email);
        this.close();
      }
    },
    close() {
      this.$emit("close");
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    Select,
    Input,
    TextArea,
    Button,
  },
  props: ["contact"],
  emits: ["close"],
};
</script>
<style scoped>
@media screen {
  #email-composition-card {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .scs-input {
    width: 100%;
  }

  .scs-button {
    margin-top: 15px;
  }
  @media (min-width: 800px) {
    .scs-input {
      min-width: 300px;
    }
  }
}
</style>
